export default __webpack_public_path__ + "static/media/news91.3935b42e.jpg";